const map = {
	"./collabora.png": 6085,
	"./dmonk.png": 8457,
	"./dropbox.png": 73,
	"./excalidraw.png": 2454,
	"./googledrive.png": 599,
	"./miro.png": 9757,
	"./mistral.png": 6544,
	"./monday.png": 2846,
	"./notion.png": 525,
	"./onedrive.png": 4610
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3369;